<div class="mb-3">
  <div class="row">
    <div class="col-sm-5">
      <select [(ngModel)]="phoneCountryCode" (change)="updatePhoneNumber()" class="form-select" bkInput name="phone_code" [required]="required">
        <option *ngFor="let countryData of countryDatas" [value]="countryData.phone_code">
          {{countryData.name}} {{countryData.phone_code}}
        </option>
      </select>
    </div>
    <div class="col-sm-7">
      <input type="tel" [(ngModel)]="phoneNumber" (change)="updatePhoneNumber()" (blur)="updatePhoneNumber()"
        class="form-control" bkInput [class.is-invalid]="hasInvalidValue" [required]="required">
      <div *ngIf="showInvalid" class="invalid-feedback">
        Please enter a valid phone number.
      </div>
    </div>
  </div>
</div>
